import { useFeatureFlags } from '@src/data/selectors/app-config-selectors'
import EditPersonalLoanWorksheetPageV2 from './EditPersonalLoanWorksheetPageV2'
import LegacyEditPersonalLoanWorksheetPage from './LegacyEditPersonalLoanWorksheetPage'

// Display gate for the BaseWorksheetForm rewrite: UseCustomFlashPlan turns on the server-driven
// term-and-plan experience (same gate MerchantDashboard shipped with); the legacy page stays the
// fallback/kill-switch until the switch is retired.
const EditPersonalLoanWorksheetPage = () => {
  const featureFlags = useFeatureFlags()
  return featureFlags.useCustomFlashPlan ? (
    <EditPersonalLoanWorksheetPageV2 />
  ) : (
    <LegacyEditPersonalLoanWorksheetPage />
  )
}

export default EditPersonalLoanWorksheetPage
